import { useMutation } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";
import { message } from "antd";
import { adminLoginAsPartner } from "../../services/client";
import { adminAuthHeaders } from "./adminAuthHeaders";

type OpenSiteTarget = {
  partnerId: string;
  siteId: string;
  tab?: string;
};

export const useOpenSiteAsPartner = () => {
  const navigate = useNavigate();
  return useMutation({
    mutationFn: ({ partnerId }: OpenSiteTarget) =>
      adminLoginAsPartner({
        throwOnError: true,
        headers: { ...adminAuthHeaders(), partner_id: partnerId },
      }),
    onSuccess: ({ data }, { siteId, tab }) => {
      localStorage.setItem("token", data.access_token);
      navigate(tab ? `/sites/${siteId}?tab=${tab}` : `/sites/${siteId}`);
    },
    onError: () => {
      message.error("Failed to login as partner");
    },
  });
};
